import React from 'react';
import PropTypes from 'prop-types';

import Thumbnail from '@/shared/components/photo_gallery/components/thumbnail';

const PAGER_NUM = 12;

export default class Gallery extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            photos: props.photos,
            offset: PAGER_NUM,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            photos: nextProps.photos,
            offset: PAGER_NUM * nextProps.page,
        });
    }

    render() {
        if (this.state.photos.length == 0) {
            return <p className="lead-text">表示できるフォトがありません</p>;
        }

        const thumbnails = this._displayPhotos().map((photo, i) => {
            return (
                <Thumbnail
                    photo={photo}
                    clickPhoto={this.props.clickPhoto}
                    accentColor={this.props.accentColor}
                    index={i}
                    key={i}
                />
            );
        });

        return (
            <div className="photo__inner">
                <ul className="photo__list">{thumbnails}</ul>
                {this._renderPager()}
            </div>
        );
    }

    // Pager
    _renderPager() {
        if (this.state.offset >= this.state.photos.length) {
            return null;
        }

        return (
            <div id="more_result" className="btn--more border-color--sub">
                <a
                    id="more_click"
                    className="btn--more__click color--sub border-radius--btn font-family--middle"
                    href="#"
                    onClick={this._handleClick.bind(this)}
                >
                    次の{PAGER_NUM}件を読み込む
                </a>
            </div>
        );
    }

    // 表示するフォトを返却します
    _displayPhotos() {
        return this.state.photos.slice(0, this.state.offset);
    }

    // Pager を Click
    _handleClick(e) {
        e.preventDefault();
        this.props.clickPager(this.props.page + 1);
    }
}

Gallery.propTypes = {
    photos: PropTypes.array.isRequired,
    page: PropTypes.number.isRequired,
    accentColor: PropTypes.string.isRequired,
    clickPhoto: PropTypes.func.isRequired,
    clickPager: PropTypes.func.isRequired,
};
